var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"button_back md-primary md-sm md-simple",on:{"click":_vm.handleBackButtonClick}},[_c('md-icon',[_vm._v("keyboard_arrow_left")]),_vm._v(" "+_vm._s(_vm.backButtonText)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }